/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartDiagram = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2H2v20h20v-2H4zm3.912 12.805c.732-1.626 1.863-3.464 3.54-4.316 1.554-.789 3.897-.878 7.46 1.714l1.176-1.617c-3.937-2.866-7.094-3.122-9.54-1.88-2.323 1.18-3.692 3.57-4.46 5.278z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartDiagram as ChartDiagram };
